const handleNotifications = ((jQuery) => {
  'use strict'

  const notificationItems = jQuery('.notification-item');
  if (notificationItems.length === 0) {
    return;
  }

  jQuery(function () {
    notificationItems.on('click', (e) => {
      e.stopPropagation();

      let notificationId = jQuery(e.currentTarget).attr('data-id');
      let csrfToken = jQuery('meta[name=csrf-token]').attr('content');

      jQuery.ajax({
        url: '/profile/notifications/read/' + notificationId,
        type: "GET",
        dataType: "json",
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': csrfToken
        },
        success: function (data) {
          let notificationBadge = jQuery(e.currentTarget).find('.unread-badge');
          if (notificationBadge) {
            notificationBadge.remove();
          }

          let notificationCounter = jQuery('#notification-counter');
          if (data.unread >= 0) {
            if (data.unread == 0) {
              notificationCounter.remove();
            } else {
              notificationCounter.text(data.unread);
            }
          }
        },
      });
    });
  });

})(jQuery);
